import React, { useEffect, useState } from "react";
import { Tooltip } from "react-tooltip";
import { useSelector } from "react-redux";
import { calculateTotals, cuFormat } from "../../../../components/table/coreUiTable/Format";
import TableWithCustomSearch from "../../../../components/table/coreUiTableWithCustomSearchAndDateConversion/TableWithCustomSearch";

export const StaffSalesTable = () => {
  let [filteredData, setFilteredData] = useState([]);
  let [totalsForExport, setTotalsForExport] = useState([]);
  let [totalSlots, setTotalSlots] = useState([]);
  const {
    data = [],
    colHeaders = [],
    columns = [],
    links = [],
    rowCalculations = [],
    rawDataLink,
    colHeaderTooltips
  } = useSelector((state) => state.staffSales.tableData);

  const formattedSlots = cuFormat({
    headers: colHeaders,
    columns: columns,
    links: links
  });

  useEffect(() => {
    let totals = ["Total"];

    const totalRow = colHeaders.slice(1).map((header, index) => {
      const renderFunc = formattedSlots[header];
      const calculatedValue = calculateTotals(
        filteredData,
        rowCalculations[index + 1],
        colHeaders,
        header
      );
      const value = {
        [header]: calculatedValue
      };

      totals.push(calculatedValue);

      return renderFunc(value, {});
    });

    setTotalSlots(totalRow);
    setTotalsForExport(totals);
  }, [filteredData]);

  const onFilteredItemsChange = (data) => {
    setFilteredData(data);
  };
  const tooltipId = "staff-sales-date-table-header-tooltip";

  const columnHeaderSlot = colHeaderTooltips.reduce((acc, column) => {
    acc[column.columnHeader] = (
      <div
        className="d-inline"
        data-tooltip-id="staff-sales-date-table-header-tooltip"
        data-tooltip-content={column?.tooltip}
      >
        {column?.label}
      </div>
    );
    return acc;
  }, {});

  return (
    <>
      <TableWithCustomSearch
        table={{ data, colHeaders }}
        data={data}
        colHeaders={colHeaders}
        columns={columns}
        links={links}
        rawDataLink={rawDataLink}
        onFilteredItemsChange={onFilteredItemsChange}
        pagination
        itemsPerPage={9}
        additionalDataToExport={totalsForExport}
        footerSlot={
          filteredData.length > 1 ? (
            <tfoot>
              <tr className="">
                <td></td>
                <td>Total</td>
                {totalSlots}
              </tr>
            </tfoot>
          ) : null
        }
        columnHeaderSlot={columnHeaderSlot}
        fileName="staff-sales-and-conversions"
        hideFirstCol
      />
      <Tooltip id={tooltipId} float />
    </>
  );
};
